<div id="no-more-tables">
  <form class="disabled">
    <table class="table preload">
      <thead>
        <tr>
          <th scope="col">Cabin:</th>
          <th scope="col">Bed Type:</th>
          <th scope="col" colspan="2">Number of Passengers:</th>
          <th scope="col">Price:</th>
          <th scope="col">&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <td  data-title="Cruise:">
           <div class="form-grp2">

             <input  id="reference" maxlength="300" name="reference" type="text"
           class="form-control"  />
           </div>  
        </td>
        <td  data-title="Cruise:">
           <div class="form-grp2">

             <input  id="reference" maxlength="300" name="reference" type="text"
           class="form-control"  />
           </div>  
        </td>
        <td  data-title="Cruise:">
           <div class="form-grp2">

             <input  id="reference" maxlength="300" name="reference" type="text"
           class="form-control"  />
           </div>  
        </td>
        <td  data-title="Cruise:">
           <div class="form-grp2">

             <input  id="reference" maxlength="300" name="reference" type="text"
           class="form-control"  />
           </div>  
        </td>
        <td  data-title="Cruise:">
           <div class="form-grp2">

             <input  id="reference" maxlength="300" name="reference" type="text"
           class="form-control"  />
           </div>  
        </td>
      </tbody>
    </table>
    <a class="lngnext" id="pluscabin" aria-disabled="true" 
    [ngStyle]="{ 'background-color': getSecundaryColor() }">
      <img src="assets/images/plus.png" width="20" height="20" alt=""> Add a Cabin
    </a>
  </form>
  <hr class="dotted">
  <h3>Contact Information</h3>


  <form class="disabled">
    <div class="form-grp">
      <label for="email">E-mail (*):</label>
      <input  id="Email" maxlength="300" name="email"
        pattern="^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,3})$" type="text" class="form-control"
        required email />

    </div>
    <div class="form-grp">
      <label for="telephone">Telephone: </label>
      <input  id="telephone" maxlength="300" name="telephone" type="text"
        class="form-control" />
    </div>
    <div class="form-grp">
      <label for="reference">Reference Name(*):</label>
      <input  id="reference" maxlength="300" name="reference" type="text"
        class="form-control" required />

    </div>
    <div class="form-grp">
      <label for="agency">Agency Name (if apply):</label>
      <input  id="agency" maxlength="300" name="agency" type="text" class="form-control" />
    </div>
    <div class="form-grp">
      <label for="remarks">Any Questions, Comments or Special Requests::</label>
      <textarea class="comments"  style="padding-right: 3px;" cols="70" maxlength="1000"
        name="comments" rows="5" wrap="physical">
      </textarea>
    </div>
    <div class="row">
      <a class="lngnext" [ngStyle]="{ 'background-color': getSecundaryColor() }">Send</a>

    </div>
    <hr class="dotted">
  </form>
  <p style="text-align: center; margin-top: 30px;"><em><strong _ngcontent-c1="">Important: </strong>Certain
      filters and security settings may prevent our emails (responses) from arriving in your inbox so please
      be sure to check your junk, trash or spam folders.</em></p>
</div>